import { useTranslation } from "react-i18next";

import OpsMateRouteShell from "@/pages/opsmate/components/OpsMateRouteShell";
import AskSiteSourceTab from "./components/AskSiteSourceTab";

function AskSourcesInOpsMateInner() {
  const { i18n } = useTranslation();
  const isZh = i18n.language === "zh";

  return (
    <OpsMateRouteShell>
      <div className="flex flex-col h-full overflow-hidden bg-gray-50/60 rounded-xl">
        <div className="bg-white px-6 py-4 border-b border-gray-100">
          <div>
            <h1 className="text-xl font-bold text-gray-900">General Source</h1>
            <p className="text-sm text-gray-500 mt-0.5">
              {isZh
                ? "查看 General Site 的 AI 知识库同步状态"
                : "View AI knowledge base sync status for General sites"}
            </p>
          </div>
        </div>

        <div className="flex flex-1 overflow-hidden">
          <AskSiteSourceTab isZh={isZh} />
        </div>
      </div>
    </OpsMateRouteShell>
  );
}

export default function AskSourcesPage() {
  return <AskSourcesInOpsMateInner />;
}
